<template>
  <div class="container-custom">
    <!-- BreadScrumbs -->
    <div class="breadscrumbs">
      <a class="breadscrumbs-item active">ADATA Members</a>
    </div>
    <!-- page-actions -->
    <div class="page-actions">
      <h2>ADATA Members</h2>
      <v-spacer></v-spacer>
      <!-- <button class="btn">
        <v-icon class="mr-2">get_app</v-icon>
        <span>匯出報表</span>
      </button> -->
      <MemberExportFilter></MemberExportFilter>
    </div>
    <!--  -->
    <ADATAmembersTable></ADATAmembersTable>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import MemberExportFilter from '@/views/F-1__ADATAmembers/c/F-1-2__MemberExport_Filter.vue';
import ADATAmembersTable from '@/views/F-1__ADATAmembers/c/ADATA-members-table.vue';

export default {
  components: {
    MemberExportFilter,
    ADATAmembersTable,
  },
  async created() {
    this.clear();
    await this.getMembers();
    await this.getMemberCountries();
  },
  methods: {
    ...mapActions('member', {
      getMembers: 'find',
      getMemberCountries: 'getMemberCountries',
      clear: 'clear',
    }),
    cancelHandler() {
      this.isPageTitleInEditMode = false;
    },
    saveHandler() {
      this.isPageTitleInEditMode = false;
    },
  },
};
</script>

<style></style>
